import { newE2EPage } from "@stencil/core/testing";
import { testValidHtml } from "../../../test-utils/html-validate";

describe("ux-modal", () => {
    it("should render correctly in closed state", async () => {
        const page = await newE2EPage();
        await page.setContent(
            `<ux-modal no-close-button sticky-position="top" close-on-backdrop-click>test content</ux-modal>`
        );
        const el = await page.find("ux-modal");
        await page.waitForChanges();
        expect(el).toMatchSnapshot();
    });

    it("should render correctly in opened state", async () => {
        const page = await newE2EPage();
        await page.setContent(
            `<ux-modal opened close-button-text="CLOSE" name="foo">test content</ux-modal>`
        );
        const el = await page.find("ux-modal");
        await page.waitForChanges();
        expect(el).toMatchSnapshot();
    });

    it("should render correctly with multiple opened modals", async () => {
        const page = await newE2EPage();
        await page.setContent(
            `<div id="modals">
                <ux-modal opened name="foo">test content</ux-modal>
                <ux-modal opened name="foo2">test content</ux-modal>
            </div>`
        );
        const el = await page.find("#modals");
        await page.waitForChanges();
        expect(el).toMatchSnapshot();
    });

    it("should open and close correctly", async () => {
        const page = await newE2EPage();
        await page.setContent(
            `<ux-modal close-button-text="Schließen" close-on-esc-key="false" close-on-backdrop-click="true" name="modal-1" sticky-position="center">
                <div>Modal</div>
            </ux-modal>
            <a class="ux-button" data-trigger-modal="open,modal-1">Open Modal</a>
            <ux-modal close-button-text="Schließen" close-on-esc-key="false" close-on-backdrop-click="true" name="modal-2" sticky-position="center">
                <div>Modal</div>
            </ux-modal>
            <a class="ux-button" data-trigger-modal="open,modal-2">Open Modal</a>`
        );
        await page.waitForChanges();
        const triggerButton1 = await page.find(
            ".ux-button[data-trigger-modal='open,modal-1']"
        );
        const triggerButton2 = await page.find(
            ".ux-button[data-trigger-modal='open,modal-2']"
        );
        const modalCloseButton1 = await page.find(
            "ux-modal[name='modal-1'] .ux-modal__close"
        );
        const modalCloseButton2 = await page.find(
            "ux-modal[name='modal-2'] .ux-modal__close"
        );
        const modal1 = await page.find("ux-modal[name='modal-1']");
        const modal2 = await page.find("ux-modal[name='modal-2']");
        await triggerButton1.click();
        await page.waitForSelector("ux-modal[name='modal-1'][opened='']");
        expect(modal1).toHaveAttribute("opened");
        expect(modal2).not.toHaveAttribute("opened");
        expect(modal1).toHaveClass("ux-modal--opened");
        expect(modal2).not.toHaveClass("ux-modal--opened");
        await page.waitForChanges();
        await modalCloseButton1.click();
        await page.waitForChanges();
        expect(modal1).not.toHaveAttribute("opened");
        expect(modal2).not.toHaveAttribute("opened");
        expect(modal1).not.toHaveClass("ux-modal--opened");
        expect(modal2).not.toHaveClass("ux-modal--opened");
        await page.waitForChanges();
        await triggerButton2.click();
        await page.waitForSelector("ux-modal[name='modal-2'][opened='']");
        expect(modal2).toHaveAttribute("opened");
        expect(modal1).not.toHaveAttribute("opened");
        await page.waitForChanges();
        expect(modal2).toHaveClass("ux-modal--opened");
        expect(modal1).not.toHaveClass("ux-modal--opened");
        await page.waitForChanges();
        await modalCloseButton2.click();
        await page.waitForChanges();
        expect(modal2).not.toHaveAttribute("opened");
        expect(modal1).not.toHaveAttribute("opened");
        expect(modal1).not.toHaveClass("ux-modal--opened");
        expect(modal2).not.toHaveClass("ux-modal--opened");
    });

    it("should render valid html", async () => {
        await testValidHtml(
            `<ux-modal close-button-text="Close" name="foo">test content</ux-modal>`
        );
    });
});
